import { render, staticRenderFns } from "./Slice--Quote.vue?vue&type=template&id=18090d64&lang=pug&"
import script from "./Slice--Quote.vue?vue&type=script&lang=js&"
export * from "./Slice--Quote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports